__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-onboarding/v2_1_17/";